const tables = [
  'observation',
  'document_reference',
  'document_reference',
  'questionnaire_response',
  'patient',
  'communication',
  'care_plan',
];

const columns = [
  'meta',
  'name',
  'type',
  'resourceType',
  'id',
  'code',
  'section',
  'created',
  'effectiveDateTime',
  'authored',
  'sent',
  // Needed to redirect Document Extraction V2 AI Summary artifact citations to
  // the source document they were derived from (relatesTo[code='transforms']).
  'relatesTo',
] as const;

export type AttachmentSearchData = {
  hits: {
    hits: {
      _source: Pick<
        fhir.QuestionnaireResponse &
          fhir.Observation &
          fhir.Patient &
          fhir.DocumentReference &
          fhir.Composition &
          fhir.Questionnaire &
          fhir.Communication &
          fhir.CarePlan,
        (typeof columns)[number]
      >;
    }[];
  };
};

export const buildAttachmentSearchQuery = (attachments: string[]) => ({
  type: 'select',
  columns: columns.flatMap(field =>
    tables.map(table => ({
      expr: {
        type: 'column_ref',
        table,
        column: field,
      },
      as: field,
    })),
  ),
  from: tables.map(table => ({ table })),
  limit: [
    { type: 'number', value: 0 },
    { type: 'number', value: 1000 },
  ],
  where: {
    type: 'elasticsearch',
    query: {
      bool: {
        should: [
          ...attachments.map(attachment => ({
            bool: {
              must: [
                {
                  term: {
                    'resourceType.keyword': attachment.split('/')[0],
                  },
                },
                {
                  term: {
                    'id.keyword': attachment.split('/')[1],
                  },
                },
              ],
            },
          })),
        ],
      },
    },
  },
});
